import { isResourceEntry, waitForLoad } from "./helpers";
import { debugLog } from "./utils/logger";
import { getMonitoringUrls } from "./api";

export const collectResourceMetrics = (report: (entry: PerformanceResourceTiming) => void) => {
    if (('PerformanceObserver' in window)) {
        const resourceObserver = new PerformanceObserver((list) => {
            list.getEntries().forEach((entry) => {
                if (isResourceEntry(entry)) {
                    // Игнорируем только запросы к API мониторинга на нашем хосте
                    const url = entry.name;
                    const isMonitoringRequest = getMonitoringUrls().some(apiUrl => url.startsWith(apiUrl));

                    if (!isMonitoringRequest) {
                        debugLog("observed resource entry:", entry)
                        report(entry)
                    }
                }
            });
        });
        resourceObserver.observe({ type: "resource", buffered: true });
    }
}

export const collectNavigationMetrics = async (report: (entry: PerformanceNavigationTiming) => void) => {
    await waitForLoad();
    const navigation = performance.getEntriesByType('navigation')[0];
    debugLog("collected navigation entry:", navigation);
    report(navigation);
}
